import {
    checkError,
    getDataFromResponse,
    getDataWithPromise,
    getNumRowsFromResponse,
    Globals,
    handleAjaxError
} from "../../DataFunctions/BaseDataFns";

import React from "react";

export const groupStyles = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    color: 'green',
    fontStyle: 'bold',
    fontSize: 'large'
};

export const groupBadgeStyles = {
    backgroundColor: '#EBECF0',
    borderRadius: '2em',
    display: 'inline-block',
    fontWeight: 'normal',
    lineHeight: '1',
    minWidth: 1,
    padding: '0.16666666666667em 0.5em',
    textAlign: 'center',
    color: 'green',
    fontStyle: 'bold',
    fontSize: 'large'
};

export const formatGroupLabel = data => (
    <div style={groupStyles}>
        <span>{data.label}</span>
        <span style={groupBadgeStyles}>{data.options.length}</span>
    </div>
);

const groupedOptions = ( data ) =>
{
    let groups = [] ;

    let houseGroups = data.filter ( (elem) => { if ( elem.entity_type == 1 ) { return elem }}).map ( (elem) => { return { value: elem.team_id, label: elem.name, color: elem.hex_color }});
    let classGroups = data.filter ( (elem) => { if ( elem.entity_type == 2 ) { return elem }}).map ( (elem) => { return { value: elem.team_id, label: elem.name, color: elem.hex_color }});
    let clubGroups = data.filter ( (elem) => { if ( elem.entity_type == 3 ) { return elem }}).map ( (elem) => { return { value: elem.team_id, label: elem.name, color: elem.hex_color }});

    if ( houseGroups.length > 0 )
    {
        groups.push ( { label: 'House Teams', options: houseGroups}) ;
    }

    if ( classGroups.length > 0 )
    {
        groups.push ( { label: 'Classes', options: classGroups}) ;
    }

    if ( clubGroups.length > 0 )
    {
        groups.push ( { label: 'Club Teams', options: clubGroups}) ;
    }

    return ( groups );
}

export const getCompetitionData = ( customer_id, competition_id) =>
{
    const url = Globals.APIFolder + '/customers/' + customer_id + '/competitions/' + competition_id + '/teams?not-participating' ;

    return new Promise((resolve, reject) =>
    {
        if (url == null || url == '')
        {
            throw Error('getDataWithPromise cannot call an empty URL');
        }
        else
        {
            getDataWithPromise(url, 'GET', {}).then(response =>
            {
                const rows = getNumRowsFromResponse(response) > 0 ? getDataFromResponse(response) : [];

                resolve ( groupedOptions(rows)) ;
            })
            .catch((jqXHR, textStatus, error) =>
            {
                reject(jqXHR, textStatus, error);
            });
        }
    });
}

const ungroupedTeamMembers = ( data ) =>
{
    const groups = data.map ( (elem) => { return { value: elem.user_id, label: elem.firstname + ' ' + elem.surname }});

    return ( groups );
}

export const getTeamMembers = ( customer_id, team_id) =>
{
    const url = Globals.APIFolder + '/customers/' + customer_id + '/teams/' + team_id + '/members?missing-only' ;

    return new Promise((resolve, reject) =>
    {
        if (url == null || url == '')
        {
            throw Error('getDataWithPromise cannot call an empty URL');
        }
        else
        {
            getDataWithPromise(url, 'GET', {}).then(response =>
            {
                const rows = getNumRowsFromResponse(response) > 0 ? getDataFromResponse(response) : [];

                resolve ( ungroupedTeamMembers(rows)) ;
            })
                .catch((jqXHR, textStatus, error) =>
                {
                    reject(jqXHR, textStatus, error);
                });
        }
    });
}

export const getCustomerClasses = ( customer_id ) =>
{
    const ungroupedClasses = ( data ) =>
    {
        const groups = data.map ( (elem) => { return { value: elem.team_id, label: elem.name}});

        return ( groups );
    }

    const url = Globals.APIFolder + '/customers/' + customer_id + '/class?list' ;

    return new Promise((resolve, reject) =>
    {
        if (url == null || url == '')
        {
            throw Error('getDataWithPromise cannot call an empty URL');
        }
        else
        {
            getDataWithPromise(url, 'GET', {}).then(response =>
            {
                const rows = getNumRowsFromResponse(response) > 0 ? getDataFromResponse(response) : [];

                resolve ( ungroupedClasses(rows)) ;
            })
                .catch((jqXHR, textStatus, error) =>
                {
                    reject(jqXHR, textStatus, error);
                });
        }
    });
}

export const getCustomerDistricts = ( customer_id ) =>
{
    const ungroupedClasses = ( data ) =>
    {
        const groups = data.map ( (elem) => { return { value: elem.team_id, label: elem.name}});

        return ( groups );
    }

    const url = Globals.APIFolder + '/customers/' + customer_id + '/districts?list' ;

    return new Promise((resolve, reject) =>
    {
        if (url == null || url == '')
        {
            throw Error('getDataWithPromise cannot call an empty URL');
        }
        else
        {
            getDataWithPromise(url, 'GET', {}).then(response =>
            {
                const rows = getNumRowsFromResponse(response) > 0 ? getDataFromResponse(response) : [];

                resolve ( ungroupedClasses(rows)) ;
            })
            .catch((jqXHR, textStatus, error) =>
            {
                reject(jqXHR, textStatus, error);
            });
        }
    });
}

export const getCustomerAttendanceOfficersForSchool = ( school_id ) =>
{
    const ungroupedClasses = ( data ) =>
    {
        let groups = data.map ( (elem) => { return { value: +(elem.user_id), label: elem.name}});

        // Add the desi teacher option to allow un-selection of the attendance officer
        groups = [ ... groups, { value: -1, label: 'Designated Teacher'} ] ;

        return ( groups );
    }

    const url = Globals.APIFolder + '/schools/' + school_id + '/attendanceofficers' ;

    return new Promise((resolve, reject) =>
    {
        if (url == null || url == '')
        {
            throw Error('getDataWithPromise cannot call an empty URL');
        }
        else
        {
            getDataWithPromise(url, 'GET', {}).then(response =>
            {
                const rows = getNumRowsFromResponse(response) > 0 ? getDataFromResponse(response) : [];

                resolve ( ungroupedClasses(rows)) ;
            })
                .catch((jqXHR, textStatus, error) =>
                {
                    reject(jqXHR, textStatus, error);
                });
        }
    });
}

export const getSchoolGroups = ( authority_id ) =>
{
    const ungroupedClasses = ( data ) =>
    {
        const groups = data.map ( (elem) => { return { value: elem.school_group_id, label: elem.school_group_name}});

        return ( groups );
    }

    const url = Globals.APIFolder + '/schoolgroups?authorityid=' + authority_id ;

    return new Promise((resolve, reject) =>
    {
        if (url == null || url == '')
        {
            throw Error('getDataWithPromise cannot call an empty URL');
        }
        else
        {
            getDataWithPromise(url, 'GET', {}).then(response =>
            {
                const rows = getNumRowsFromResponse(response) > 0 ? getDataFromResponse(response) : [];

                resolve ( ungroupedClasses(rows)) ;
            })
                .catch((jqXHR, textStatus, error) =>
                {
                    reject(jqXHR, textStatus, error);
                });
        }
    });
}

export const getSchoolYearData = ( includeEarly ) =>
{
    let years = [] ;

    if ( includeEarly === true )
    {
        years = [
            { value: 14, label: 'Reception'},
            { value: 15, label: 'Nursery'},
            { value: 1, label: 'Year 1'},
            { value: 2, label: 'Year 2'},
            { value: 3, label: 'Year 3'},
            { value: 4, label: 'Year 4'},
            { value: 5, label: 'Year 5'},
            { value: 6, label: 'Year 6'},
            { value: 7, label: 'Year 7'},
            { value: 8, label: 'Year 8'},
            { value: 9, label: 'Year 9'},
            { value: 10, label: 'Year 10'},
            { value: 11, label: 'Year 11'},
            { value: 12, label: 'Year 12'}];
    }
    else
    {
        years = [
            { value: 1, label: 'Year 1'},
            { value: 2, label: 'Year 2'},
            { value: 3, label: 'Year 3'},
            { value: 4, label: 'Year 4'},
            { value: 5, label: 'Year 5'},
            { value: 6, label: 'Year 6'},
            { value: 7, label: 'Year 7'},
            { value: 8, label: 'Year 8'},
            { value: 9, label: 'Year 9'},
            { value: 10, label: 'Year 10'},
            { value: 11, label: 'Year 11'},
            { value: 12, label: 'Year 12'}];
    }

    return new Promise((resolve, reject) =>
    {
        resolve(years);
    });
}

export const getEthnicityData = () =>
{
    const options = [
    {
            label: "White",
            options: [
                { label: "English, Welsh, Scottish, Northern Irish or British", value: 1 },
                { label: "Irish", value: 2 },
                { label: "Gypsy or Traveller", value: 3 },
                { label: "Any other White background", value: 4 },
            ]
        },
        {
            label: "Mixed or Multiple ethnic groups",
            options: [
                { label: "White and Black Caribbean", value: 5 },
                { label: "White and Black African", value: 6 },
                { label: "White and Asian", value: 7 },
                { label: "Any other Mixed or Multiple ethnic background", value: 8 },
            ]
        },
        {
            label: "Asian or Asian British",
            options: [
                { label: "Indian", value: 9 },
                { label: "Pakistani", value: 10 },
                { label: "Bangladeshi", value: 11 },
                { label: "Any other Asian background", value: 12 },
            ]
        },
        {
            label: "Black, African, Caribbean or Black British",
            options: [
                { label: "African", value: 13 },
                { label: "Caribbean", value: 14 },
                { label: "Any other Black, African or Caribbean background", value: 15 },
            ]
        },
        {
            label: "Other ethnic group",
            options: [
                { label: "Arab", value: 16 },
                { label: "Any other ethnic group", value: 17 },
            ]
        },
    ];

    return new Promise((resolve, reject) =>
    {
        resolve(options);
    });
}

export const getYesNoData = () =>
{
    let options =
    [
        { value: 'Y', label: 'Yes'},
        { value: 'N', label: 'No'},
    ];

    return new Promise((resolve, reject) =>
    {
        resolve(options);
    });
}

export const getYesNoUnknownData = () =>
{
    let options =
        [
            { value: 'Y', label: 'Yes'},
            { value: 'N', label: 'No'},
            { value: 'U', label: 'Unknown'},
        ];

    return new Promise((resolve, reject) =>
    {
        resolve(options);
    });
}

export const getGenderData = () =>
{
    let options =
        [
            { value: 'M', label: 'Male'},
            { value: 'F', label: 'Female'},
        ];

    return new Promise((resolve, reject) =>
    {
        resolve(options);
    });
}

